import {ForgotPasswordConfirm} from 'domain/usecases';
import {RemoteForgotPasswordConfirm} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {EntryFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makeForgotPasswordConfirm = (): ForgotPasswordConfirm =>
	new RemoteForgotPasswordConfirm(
		makeBFFApiUrl(EntryFlowEndPoints.forgotConfirmRegistration),
		makeAuthorizeHttpClientDecorator(),
	);
